
import { defineComponent, PropType } from 'vue'
import { iScorecard, iScorecardCriterion, iPerspective, iKpi } from '../Scorecards'
import { getDefaultCriterion } from '../ScorecardsHelpers'
import ScorecardsPerspectiveItem from './ScorecardsPerspectiveItem.vue'
import ScorecardsTableHint from './ScorecardsTableHint.vue'

const crypto = require('crypto')

export default defineComponent({
    name: 'scorecards-table',
    components: { ScorecardsPerspectiveItem, ScorecardsTableHint },
    props: { propScorecard: { type: Object as PropType<iScorecard> }, criterias: { type: Array as PropType<iScorecardCriterion[]>, required: true }, kpis: { type: Array as PropType<iKpi[]>, required: true } },
    emits: ['touched'],
    data() {
        return {
            scorecard: null as iScorecard | null
        }
    },
    watch: {
        propScorecard() {
            this.loadScorecard()
        }
    },
    created() {
        this.loadScorecard()
    },
    methods: {
        loadScorecard() {
            this.scorecard = this.propScorecard as iScorecard
        },
        addPerspective() {
            if (this.scorecard) {
                this.scorecard.perspectives.push({ id: crypto.randomBytes(16).toString('hex'), name: 'New Perspective', status: 'GRAY', criterion: getDefaultCriterion(this.criterias), options: { criterionPriority: [] }, targets: [], groupedKpis: [], new: true  })
                this.$emit('touched')
            }
        },
        deletePerspective(perspective: iPerspective) {
            if (!this.scorecard) return
            const index = this.scorecard.perspectives.findIndex((tempPerspective: iPerspective) => tempPerspective.id === perspective.id)
            if (index !== -1) {
                this.scorecard.perspectives.splice(index, 1)
                this.$emit('touched')
            }
        }
    }
})
